<nz-table
  #nzTable
  class="v4-layout-list mt-[30px]"
  [nzFrontPagination]="false"
  [nzData]="listOfOrder"
  [nzTotal]="total"
  [(nzPageIndex)]="page"
  [nzPageSize]="pageSize"
  nzPaginationType="small"
  [nzShowTotal]="totalTpl"
  (nzPageIndexChange)="onPageChange.emit($event)">
  <thead>
    <tr>
      <th
        *ngIf="checkable"
        [nzShowCheckbox]="true"
        [nzChecked]="checkableList.allChecked"
        [nzIndeterminate]="checkableList.indeterminate"
        (nzCheckedChange)="checkableList.onAllChecked($event)"></th>
      <th class="w-[150px]">{{ "reservation.table.column.name" | translate }}</th>
      <th class="w-[170px]">{{ "reservation.table.column.property" | translate }}</th>
      <th class="w-[170px]">{{ "reservation.table.column.check" | translate }}</th>
      <th>{{ "reservation.table.column.price" | translate }}</th>
      <th class="w-[150px]">{{ "reservation.table.column.tags" | translate }}</th>
      <th>{{ "reservation.table.column.other_fee" | translate }}</th>
      <th>{{ "reservation.table.column.book_time" | translate }}</th>
      <th></th>
    </tr>
  </thead>
  <tbody class="v4-layout-list-body">
    <ng-container *ngFor="let row of nzTable.data">
      <tr
        *ngFor="let item of row.reservations; index as i"
        class="cursor-pointer"
        [class.hovering]="item.hovering"
        (mouseover)="onHoverRow(row, true)"
        (mouseout)="onHoverRow(row, false)"
        (click)="onClickReservation.emit(row.code)">
        <td
          *ngIf="checkable"
          [nzShowCheckbox]="true"
          [nzChecked]="checkableList.setOfCheckedId.has(item.code)"
          (nzCheckedChange)="checkableList.onItemChecked(item.code, $event)"></td>
        <td [attr.rowspan]="row?.reservations?.length || 1" *ngIf="i === 0">
          <div class="flex flex-row items-center">
            <img class="w-7 h-7 rounded-full mr-3" [src]="row?.logos?.color" alt="" />
            <div>
              <div>{{ row?.client?.name }}</div>
              <div>
                <i nz-icon nzType="team" nzTheme="outline"></i>
                {{ row?.number_of_guests }}
              </div>
            </div>
          </div>
        </td>

        <td nzBreakWord (click)="$event.stopPropagation(); onClickReservation.emit(item.code)">
          <div>
            @if (item.house?.is_deleted) {
              <span class="v4-tag deleted inline-block mr-[8px]">
                {{ "word.deleted" | translate }}
              </span>
            }
            {{ item?.house?.title }}
          </div>
          <div class="checkin-status pending" *ngIf="row.is_pending_verify === 1; else normalStatus">
            {{ "order_status.is_pending_verify" | translate }}
          </div>
          <ng-template #normalStatus>
            <div
              class="checkin-status"
              [class.wait-stay]="item?.out_status === 'wait_stay'"
              [class.staying]="item?.out_status === 'staying'"
              [class.completed]="item?.out_status === 'completed'">
              {{ "order_status." + item?.out_status | translate }}
            </div>
          </ng-template>
        </td>

        <td (click)="$event.stopPropagation(); onClickReservation.emit(item.code)">
          <div>
            <div class="checkin-range">
              {{ item?.check_in | dateformat: ["MD"] }}
              ~ {{ item?.check_out | dateformat: ["MD"] }}
            </div>
            <div *ngIf="item.reservation_checkin_time.check_in_time || item.reservation_checkin_time.check_out_time">
              <span class="mr-[8px]">
                <img class="w-[12px]" src="/assets/v4/icon-check-in.svg" alt="" />
                @if (item.reservation_checkin_time.check_in_time; as checkin) {
                  <span class="align-middle">{{ "2024-11-11T" + checkin | dateformat: [null, "hm"] }}</span>
                } @else {
                  <span class="align-middle">--:--</span>
                }
              </span>
              <span>
                <img class="w-[12px]" src="/assets/v4/icon-check-out.svg" alt="" />
                @if (item.reservation_checkin_time.check_out_time; as checkout) {
                  <span class="align-middle">{{ "2024-11-11T" + checkout | dateformat: [null, "hm"] }}</span>
                } @else {
                  <span class="align-middle">--:--</span>
                }
              </span>
            </div>
          </div>
        </td>

        <td (click)="$event.stopPropagation(); onClickReservation.emit(item.code)">
          <div>
            <div class="v4-layout-text-lines">
              <div class="v4-layout-text-line">
                <span> {{ row?.currency_type | currencyToSymbol }}{{ item?.house_fee?.amount }} </span>
                <span *ngIf="[0, 2].indexOf(row?.settlement?.status) !== -1"
                  >({{ "order.money_cleared" | translate }})</span
                >
                <span *ngIf="row?.settlement?.status === 1">({{ "order.unpaid" | translate }} )</span>
              </div>
              <div class="v4-layout-text-line">
                <span>{{ "word.commission" | translate }} {{ row?.commission?.amount }}</span>
                &nbsp;&nbsp;
                <span *ngIf="!isInternational">{{ "order.net_fee" | translate }} {{ row?.net_house_fee?.amount }}</span>
              </div>
            </div>
          </div>
        </td>

        <!-- 标签 -->
        <td (click)="$event.stopPropagation(); onClickReservation.emit(item.code)">
          <div>
            <div class="v4-tag-list">
              <!-- 手工单 -->
              <div class="mr-2 py-1" *ngIf="row.thirdparty_type === 5">
                <div class="v4-tag handmade">
                  {{ "order.handmade_order" | translate }}
                </div>
              </div>
              <!-- 小时单  -->
              <div class="mr-2 py-1" *ngIf="item?.is_hour_reservation">
                <div class="v4-tag hour">
                  {{ "order_status.hour_reservation" | translate }}
                </div>
              </div>
              <!-- 冲突单 -->
              <div class="mr-2 py-1" *ngIf="item?.conflict_label?.is_conflict">
                <div class="v4-tag conflict">
                  {{ "order.conflict_order" | translate }}
                </div>
              </div>
              <!-- 门锁 -->
              <div class="mr-2 py-1" *ngIf="item?.tip_no_lock_password">
                <div class="v4-tag smart-lock">
                  {{ "order.no_lock_password" | translate }}
                </div>
              </div>
              <!-- 订单标签 -->
              <div class="mr-2 py-1" *ngFor="let tag of item?.reservation_tag">
                <div class="v4-tag" [style.background]="tag.color">{{ tag.tag_name }}</div>
              </div>
              <!-- 现付单 -->
              <div class="mr-2 py-1" *ngIf="item?.pay_on_site">
                <div class="v4-tag pay-on-site">{{ "order_status-ctrip-现付" | translate }}</div>
              </div>
              <!-- 背对背订单 -->
              <div class="mr-2 py-1" *ngIf="row?.back_to_back">
                <div class="v4-tag inline-block !text-primary bg-[#e9f3ff]">
                  {{ "task.word.back_to_back" | translate }}
                </div>
              </div>
            </div>

            <div class="text-xs mt-1 ellipsis-line-3">{{ item.note || item.remark }}</div>
          </div>
        </td>

        <!-- 其他收支 -->

        <td [attr.rowspan]="row?.reservations?.length || 1" *ngIf="i === 0">
          <div class="v4-layout-text-lines">
            <div class="v4-layout-text-line">
              + {{ row?.currency_type | currencyToSymbol }}{{ row?.other_income?.amount }}
            </div>
            <div class="v4-layout-text-line">
              - {{ row?.currency_type | currencyToSymbol }}{{ row?.expense?.amount }}
            </div>
          </div>
        </td>

        <!-- booking time -->
        <td [attr.rowspan]="row?.reservations?.length || 1" *ngIf="i === 0">
          <div class="v4-layout-text-lines">
            <div class="v4-layout-text-link">{{ row?.booked_time | dateformat: ["MD", "hm"] }}</div>
            <div class="v4-layout-text-link">{{ row?.creator?.name }}</div>
          </div>
        </td>

        <td class="text-right" (click)="$event.stopPropagation()">
          <div>
            <div class="mb-1">
              <button
                nz-button
                nzSize="small"
                *ngIf="item?.out_status === 'wait_stay'"
                (click)="onClickCheckButton(item)">
                {{ "order.check_in" | translate }}
              </button>
            </div>
            <div class="mb-1">
              <button
                nz-button
                nzSize="small"
                *ngIf="item?.out_status === 'staying'"
                (click)="onClickCheckButton(item)">
                {{ "order.check_out" | translate }}
              </button>
            </div>
            <ng-container *ngIf="operateType === 'detail'">
              <div class="mb-1">
                <button
                  nz-button
                  nzSize="small"
                  *ngIf="item?.status === 'wait_accept'"
                  (click)="onClickDeclineButton(item)">
                  {{ "order.refuse_order" | translate }}
                </button>
              </div>
              <div class="mb-1">
                <button
                  nz-button
                  nzSize="small"
                  *ngIf="item?.status === 'wait_accept'"
                  (click)="onClickAcceptButton(item)">
                  {{ "order.accept_order" | translate }}
                </button>
              </div>
              <div>
                <button
                  nz-button
                  nzSize="small"
                  *ngIf="row?.thirdparty_type !== 5 && [0, 1].indexOf(row?.comment?.status) !== -1"
                  (click)="onClickRateButton(row)">
                  {{ "rate.operate.btn_rate" | translate }}
                </button>
              </div>
            </ng-container>
          </div>
        </td>
      </tr>
    </ng-container>
  </tbody>
</nz-table>
<ng-template #totalTpl>
  {{ "component-page_html_总数" | translate: { number: total } }}
  <!-- {{ total }} items -->
</ng-template>
